const ErrorFallback = () => (
    <div>
        An error occurred;
    </div>
)
export default ErrorFallback; 